import React, {Component} from 'react';
import "./RaikoInputStyleSheet.css"

const RaikoInput = ({labelText, placeHolder, value, setValue, onChange, spellCheck = true, inputId}) => {

    return (
        <div className="input-container">
            <label form={inputId} className="form-label">{
                labelText
            }</label>
            <input
                id={inputId}
                className="form-control"
                placeholder={placeHolder}
                spellCheck={spellCheck}
                value={value}
                onChange={e => {
                    if (onChange)
                        onChange(e)

                    if (setValue)
                        setValue(e.target.value)
                }}
            />
        </div>
    )
}

export default RaikoInput;